import { VueConstructor } from 'vue'
import { StringMap } from '@/shared/utils/map'
import { DialogRef } from '@/shared/dialog/dialog-ref'
import { DialogRefEvents } from '@/shared/dialog/dialog-ref-events'

export class DialogInstance<T> {
  public component: VueConstructor
  public events: DialogRefEvents<T>
  public props?: StringMap<any>
  public ref: DialogRef<T>

  public title = ''

  constructor(options: {
    component: VueConstructor
    events: DialogRefEvents<T>
    props?: StringMap<any>
  }) {
    this.component = options.component
    this.events = options.events
    this.props = options.props

    this.ref = new DialogRef<T>(options.events)
  }
}
